export default "__VITE_ASSET__BpJ$0fLH__"